import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AssessmentDetails from "Assessments/components/AssessmentDetails";
import { injectReducer } from "store/reducers";
import ACLStore from "lib/aclStore";
import { ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS } from "Constants/permissionConstants";
import { goToRelativeRoute } from "modules/Services";

export default store => ({
  path: "lelibrary",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "leLibrary" */ "./components"),
        import(/* webpackChunkName: "leLibrary" */ "./modules/LELibraryModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "leLibrary",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState) {
    const isGlobalHeaderOnMultipleScreensEnabled = ACLStore.can(
      ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS
    );
    const curriculumId = _.get(nextState, "params.curriculumProgramId");
    //redirecting unit library if global header is enabled
    if (isGlobalHeaderOnMultipleScreensEnabled) {
      const goToNewRoute = goToRelativeRoute({
        route: `/platform/${curriculumId}/school-library/tasks`,
        type: "replace",
      });
      store?.dispatch(goToNewRoute);
    }
  },
  childRoutes: [AssessmentDetails(store)],
});
